module.exports = __webpack_public_path__ + "img/icon-ana-forms.c4fe457c.png";